import { Injectable, inject, signal } from '@angular/core';
import jsPDF from 'jspdf';
import { Page } from '../models/template.model';
import { PdfService } from './pdf.service';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  public currentTemplate = signal<number>(0);
  public editTemplate = signal<boolean>(false);
  public selectedContracts = signal<any[]>([]);
  public cartChanged = signal(0);
  private pdfService = inject(PdfService);

  contractPdf(pages: Page[], title: string, accountId: string): Promise<void> {
    return this.pdfService.createTemplatePdf(pages, accountId, title);
  }

  checkPageLength(header: string, footer: string) {
    const doc = new jsPDF({unit: 'px', compress: true});
    return Math.floor(doc.internal.pageSize.height -
      (header !== '' ? 70 * 0.2645833333 : 0) -
      (footer !== '' ? 70 * 0.2645833333 : 40));
  }

  textHeight(content: string) {
    const doc = new jsPDF({unit: 'px', compress: true});
    const tempElement = document.createElement('div');
    tempElement.innerHTML = content;
    tempElement.style.width = doc.internal.pageSize.width + 'px';
    tempElement.style.visibility = 'hidden';
    document.body.appendChild(tempElement);
    const height = tempElement.getBoundingClientRect().height;
    document.body.removeChild(tempElement);
    return height;
  }
}
